import { toast } from "react-toastify";
import { GeneralObj } from "../types/company.types";
export const API_LINK = import.meta.env.VITE_API_URL;
import { saveAs } from "file-saver";

type Response = {
  message?: string | string[];
  data?: any;
  status?: number;
};

  function toLocalISOString(date = new Date()) {
    const offset = date.getTimezoneOffset() * 60000; // in ms
    const localISOTime = new Date(date.getTime() - offset)
      .toISOString()
      .slice(0, -1); // remove 'Z'
    return localISOTime;
  }

  function toLocalISOStringMinutes(date = new Date()) {
    return (-date.getTimezoneOffset()).toString();
  }

export const Post = async (url: string, data: any, token: string | null) => {
  try {
    const authHeader = token ? { authorization: "Bearer " + token } : null;
    const headers: HeadersInit = {
      "Content-Type": "application/json",
      // "Current-Date": toLocalISOString(),
      "utc-difference": toLocalISOStringMinutes(),
      ...authHeader,
    };
    const response = await fetch(API_LINK + url, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (e) {
    // toast.error("Something went wrong");
    console.log(e);
  }
};

export const Patch = async (url: string, data: any, token: string | null) => {
  try {
    const authHeader = token ? { authorization: "Bearer " + token } : null;
    const headers: HeadersInit = {
      "Content-Type": "application/json",
      // "Current-Date": toLocalISOString(),
      "utc-difference": toLocalISOStringMinutes(),
      ...authHeader,
    };
    const response = await fetch(API_LINK + url, {
      method: "PATCH",
      headers,
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (e) {
    toast.error("Something went wrong");
    console.log(e);
  }
};

export const SendFormData = async (
  url: string,
  data: FormData | any,
  token: string | null,
  method = "POST"
) => {
  try {
    const response = await fetch(API_LINK + url, {
      method: method,
      headers: {
        authorization: "Bearer " + token,
        // "Current-Date": toLocalISOString(),
        "utc-difference": toLocalISOStringMinutes(),
      },
      body: data,
    });
    return await response.json();
  } catch (e) {
    toast.error("Something went wrong");
    console.log(e);
  }
};

export const PatchFormData = async (
  url: string,
  data: FormData | any,
  token: string | null,
  method = "PATCH"
) => {
  try {
    const response = await fetch(API_LINK + url, {
      method: method,
      headers: {
        authorization: "Bearer " + token,
        // "Current-Date": toLocalISOString(),
        "utc-difference": toLocalISOStringMinutes(),
      },
      body: data,
    });
    return await response.json();
  } catch (e) {
    toast.error("Something went wrong");
    console.log(e);
  }
};

export const Get = async (url: string, token: string | null) => {
  try {
    const response = await fetch(API_LINK + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
        // "Current-Date": toLocalISOString(),
        "utc-difference": toLocalISOStringMinutes(),
      },
    });

    return await SendBackToBackEnd(response.json(), url, token);
  } catch (e) {
    // toast.error("Something went wrong");
    console.log(e);
  }
};

const SendBackToBackEnd = async (response: any, url: string, token: string | null) => {
  const res = await response;
  if (!res.data) {
    return await response;
  }
  if (JSON.stringify(res.data).includes('"deleted":true')) {
    // console.log(url, JSON.stringify(res.data).includes('"deleted":true'));
    await Post(`testing/catch-deleted-in-endpoints?endpoint=${url}`, {}, token);
  }
  return await response;
};

export const Delete = async (url: string, token: string | null) => {
  try {
    const response = await fetch(API_LINK + url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
        // "Current-Date": toLocalISOString(),
        "utc-difference": toLocalISOStringMinutes(),
      },
    });
    return await response.json();
  } catch (e) {
    toast.error("Something went wrong");
    console.log(e);
  }
};

export const DeleteAndSendData = async (
  url: string,
  data: any,
  token: string | null
) => {
  try {
    const response = await fetch(API_LINK + url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
        // "Current-Date": toLocalISOString(),
        "utc-difference": toLocalISOStringMinutes(),
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (e) {
    toast.error("Something went wrong");
    console.log(e);
  }
};

export const handleError = (response: Response) => {
  if (localStorage.getItem("serverMaintenance") === "true") {
    // toast.error("Server is under maintenance");
    return;
  }
  if (response?.message === "This Token Is Expired") {
    toast.error("Your session has expired, please login again");
    window.location.href = "/login";
    return;
  }
  if (typeof response?.message === "string") {
    toast.error(
      response?.message
        ? response.message || "Something went wrong"
        : "Something went wrong",
      {
        toastId: `error_${response.message}`,
      }
    );
  } else {
    response?.message?.forEach((message: string, i: number) => {
      toast.error(
        message ? message || "Something went wrong" : "Something went wrong",
        {
          toastId: `error_${response.message}_${i}`,
        }
      );
    });
  }
};
export const getExelTemplate = async (url: string, token: string | null) => {
  const res = await Get(url, token);
  if (res.error || !res.data) {
    handleError(res);
    return;
  } else {
    window.open(API_LINK + res.data.url, "_blank");
    toast.warning("Don't change the structure of the columns");
  }
};

export const ExportExelTemplate = async (
  url: string,
  data: any,
  token: string | null
) => {
  const res = await Post(url, data, token);
  if (res.error || !res.data) {
    handleError(res);
    return;
  }

  window.open(API_LINK + res.data.url, "_blank");
  toast.warning("Don't change the structure of the columns");
};

export const convertToBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export function displayToasts(response: GeneralObj) {
  Object.values(response.data.unsuccessful).forEach((entry: any) => {
    toast.error(`${entry.name} in Row ${entry.ID} : ${entry.problem}`);
  });
}

export const downloadImage = async (
  imageUrl: string,
  imageName = "downloaded_image.jpg"
) => {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    console.log(blob, "blob");
    saveAs(imageUrl, imageName);
  } catch (error) {
    console.error("Error downloading image:", error);
  }
};
